import axios from "axios";

const hostname = window.location.hostname;

const LOCAL_API_URLS = {
  localhost: "http://127.0.0.1:8000",
  "127.0.0.1": "http://127.0.0.1:8000",

  "192.168.1.20": "http://192.168.1.20:8000",
  "192.168.100.92": "http://192.168.100.92:8000",
  "192.168.100.92": "http://192.168.100.92:8000",
};

/*
 * Development:
 * localhost / LAN → Django :8000
 *
 * Production:
 * API_BASE_URL = ""
 * بنابراین:
 * /api → Nginx → Django
 */
export const API_BASE_URL = LOCAL_API_URLS[hostname] || "";
// export const API_BASE_URL = "http://192.168.100.92:8000";
const http = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  withCredentials: true,
});

/* =========================================================
   Helpers
========================================================= */

const getAccessToken = () => {
  const token = localStorage.getItem("token");

  if (
    !token ||
    token === "null" ||
    token === "undefined" ||
    token.trim() === ""
  ) {
    return null;
  }

  return token;
};

const getRefreshToken = () => {
  const token = localStorage.getItem("refresh");

  if (
    !token ||
    token === "null" ||
    token === "undefined" ||
    token.trim() === ""
  ) {
    return null;
  }

  return token;
};

const clearAuth = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refresh");
  localStorage.removeItem("role");
};

/*
 * اگر چند درخواست همزمان 401 شوند،
 * فقط یک refresh انجام می‌شود.
 */
let refreshPromise = null;

const refreshAccessToken = async () => {
  const refreshToken = getRefreshToken();

  if (!refreshToken) {
    throw new Error("Refresh token not found");
  }

  /*
   * اگر درخواست دیگری قبلاً در حال Refresh است،
   * همان Promise را استفاده می‌کنیم.
   */
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = axios
    .post(
      `${API_BASE_URL}/api/auth/refresh/`,
      {
        refresh: refreshToken,
      },
      {
        withCredentials: true,
      },
    )
    .then((response) => {
      const newAccessToken = response.data?.access;

      if (!newAccessToken) {
        throw new Error("New access token was not returned");
      }

      /*
       * Access Token جدید
       */
      localStorage.setItem("token", newAccessToken);

      /*
       * اگر Backend به دلیل
       * ROTATE_REFRESH_TOKENS
       * Refresh Token جدید هم برگرداند،
       * آن را ذخیره می‌کنیم.
       */
      if (response.data?.refresh) {
        localStorage.setItem("refresh", response.data.refresh);
      }

      return newAccessToken;
    })
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
};

/* =========================================================
   REQUEST INTERCEPTOR
========================================================= */

http.interceptors.request.use(
  (config) => {
    /*
     * درخواست‌های عمومی (send-otp, verify-otp, login-password, ...)
     * با { skipAuth: true } هیچ Authorization ای نمی‌فرستند.
     * توکن قدیمی/منقضی روی این درخواست‌ها باعث 401 می‌شود، حتی
     * اگر View روی AllowAny باشد.
     */
    if (config.skipAuth) {
      if (config.headers) {
        delete config.headers.Authorization;
      }

      return config;
    }

    const token = getAccessToken();

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    } else if (config.headers) {
      delete config.headers.Authorization;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

/* =========================================================
   RESPONSE INTERCEPTOR
========================================================= */

http.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;

    /*
     * درخواست‌های عمومی: خطا را همان‌طور که هست برگردان
     * (مثلاً «رمز عبور اشتباه است») و وارد منطق Refresh نشو.
     */
    if (originalRequest?.skipAuth) {
      return Promise.reject(error);
    }

    /*
     * فقط برای 401 تلاش به Refresh می‌کنیم.
     */
    if (
      error.response?.status !== 401 ||
      !originalRequest ||
      originalRequest._retry
    ) {
      return Promise.reject(error);
    }

    /*
     * مشخص می‌کنیم که این درخواست قبلاً
     * یک بار Refresh را امتحان کرده است.
     */
    originalRequest._retry = true;

    const refreshToken = getRefreshToken();

    /*
     * Refresh Token نداریم.
     */
    if (!refreshToken) {
      clearAuth();

      /*
       * به Login برو.
       */
      if (window.location.pathname !== "/panel/login") {
        window.location.href = "/panel/login";
      }

      return Promise.reject(error);
    }

    try {
      /*
       * گرفتن Access Token جدید
       */
      const newAccessToken = await refreshAccessToken();

      /*
       * قرار دادن Token جدید روی همان درخواست
       */
      originalRequest.headers = originalRequest.headers || {};

      originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

      /*
       * درخواست قبلی را دوباره ارسال می‌کنیم.
       */
      return http(originalRequest);
    } catch (refreshError) {
      console.error("Refresh token expired or invalid:", refreshError);

      /*
       * فقط وقتی Refresh واقعاً شکست خورد،
       * کاربر Logout می‌شود.
       */
      clearAuth();

      if (window.location.pathname !== "/panel/login") {
        window.location.href = "/panel/login";
      }

      return Promise.reject(refreshError);
    }
  },
);

export default http;
